import { useQuery } from 'react-query'

import { getScaAuthCodeUseCase } from '@webapp/platform/banking/business-logic/use-cases/GetScaAuthCode'
import { financialAccountQueryConfig } from '@webapp/platform/banking/query-configs/financialAccount'

type UseQueryScaAuthCodeReturn = {
  data: {
    authCode: string | undefined
    codeVerifier: string | undefined
  }
  isFetching: boolean
}

export const useQueryScaAuthCode = ({
  onError,
  onSuccess,
  enabled = true,
}: {
  onError?: (error: Error) => void
  onSuccess?: (data: { authCode: string; codeVerifier: string }) => void
  enabled?: boolean
}): UseQueryScaAuthCodeReturn => {
  const { data, isFetching } = useQuery({
    queryKey: financialAccountQueryConfig.getScaAuthCode().queryKey,
    queryFn: () => getScaAuthCodeUseCase(),
    onError,
    onSuccess,
    enabled,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })

  return {
    data: { authCode: data?.authCode, codeVerifier: data?.codeVerifier },
    isFetching,
  }
}
